import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgValidationFillIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.1807 14.1635C12.463 14.3073 12.6925 14.5368 12.8363 14.819C12.9893 15.1194 12.9999 15.4476 12.9998 15.7769C12.9998 15.7847 12.9998 15.7924 12.9998 15.8C12.9998 17.2744 12.9992 18.7488 12.9998 20.2231C12.9998 20.3422 12.9999 20.4845 12.9896 20.6098C12.9778 20.755 12.9473 20.963 12.8363 21.181C12.6925 21.4632 12.463 21.6927 12.1807 21.8365C11.9628 21.9476 11.7548 21.978 11.6096 21.9899C11.4843 22.0001 11.342 22.0001 11.2229 22C8.40746 21.999 5.59201 21.999 2.77657 22C2.65731 22.0001 2.51474 22.0001 2.38911 21.9898C2.24339 21.9778 2.03498 21.9472 1.81671 21.8356C1.5341 21.6911 1.30403 21.46 1.16084 21.1767C1.05054 20.9585 1.02063 20.7506 1.00926 20.6046C0.999493 20.4791 1.0002 20.3369 1.00079 20.2185C1.00594 19.1792 0.974959 18.0653 1.38037 17.0866C1.88783 15.8614 2.86121 14.8881 4.08635 14.3806C4.59605 14.1695 5.13433 14.0819 5.74307 14.0404C6.33508 14 7.06249 14 7.96425 14C9.05046 14 10.1367 14.0004 11.2229 14C11.5522 13.9999 11.8803 14.0104 12.1807 14.1635Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.7069 15.2929C23.0974 15.6834 23.0974 16.3166 22.7069 16.7071L18.7069 20.7071C18.3163 21.0976 17.6832 21.0976 17.2927 20.7071L15.2927 18.7071C14.9021 18.3166 14.9021 17.6834 15.2927 17.2929C15.6832 16.9024 16.3163 16.9024 16.7069 17.2929L17.9998 18.5858L21.2927 15.2929C21.6832 14.9024 22.3163 14.9024 22.7069 15.2929Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5728 2.91554C14.7801 2.40361 15.363 2.1566 15.875 2.36382C17.7055 3.10481 18.9998 4.90006 18.9998 7C18.9998 9.09994 17.7055 10.8952 15.875 11.6362C15.363 11.8434 14.7801 11.5964 14.5728 11.0845C14.3656 10.5725 14.6126 9.98953 15.1245 9.7823C16.2258 9.33652 16.9998 8.25744 16.9998 7C16.9998 5.74256 16.2258 4.66348 15.1245 4.2177C14.6126 4.01047 14.3656 3.42748 14.5728 2.91554Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.49976 7C4.49976 4.23858 6.73834 2 9.49976 2C12.2612 2 14.4998 4.23858 14.4998 7C14.4998 9.76142 12.2612 12 9.49976 12C6.73834 12 4.49976 9.76142 4.49976 7Z"
		})
	]
});
export default SvgValidationFillIcon;
